import {paths} from '@src/consts';
import localStore from '@src/utils/storage';
import crypto from '@src/utils/encrypt';
import apiStore from './index';
import { getFormData } from './utils';
import getLangs from './Lang' ;

const logger=Logger.get('apis/auth');

const fetchEmail = async ( { email } ) => {

    const params = { email };
    const { data:body } = await apiStore.axios.get( paths.checkEmail, { params });
    if( body.error ) throw body;
    return body ? { ...body , email }: { email, success: false }
    
}

/**
 * 
 * @param { Object } payload { email, password }
 */

const fetchLogin = async ( payload = {}, syncData = false, config = null ) => {

    const params = syncData ? syncLocalUserData( payload ) : payload ;

    if( !Object.keys( params ).length ) throw new Error('no credentials found');
    const formData = getFormData( params );

    const { data:body } = await apiStore.axios.post (paths.login , formData)

    body.languageList = await getLangs( body.additionallanguage );

    storeUserDetails( params );
    return  body;
}

export const fetchguestLogin = async ( payload = {}, syncData = false, config = null ) => {
    const params =  payload ;

    if( !Object.keys( params ).length ) throw new Error('no credentials found');
    const formData = getFormData( params );

    const { data:body } = await apiStore.axios.post (paths.login , formData)

    body.languageList = await getLangs( body.additionallanguage );

    // storeUserDetails( params );
    return  body;
}

const fetchSignUp = async ( data ) => {
    const { email, password,subscribername,country,contactno,countrycode } = data;
    const params = { email, password,subscribername,country};
    if(contactno) {
        params.contactno = contactno;
        params.countrycode = countrycode
    }
    const formData = getFormData( params );
    const { data:body } = await apiStore.axios.post( paths.signup, formData );

    if( !body.success ) throw body; 

    storeUserDetails( { email, password } );
   
    return body;
}

const requestLogout = async () => {
    const { data : body } = await apiStore.axios.get( paths.logout ) ;
    if( !body.success ) throw new Error('logout failed'); 
    localStore.remove( '__userdata__' );
    return body ;
}

const fetchForgotPassword = async ( payload = {} ) => {

    const { email } = payload
    
    if( !email ) return Promise.reject( { message: "Email is required" } );

    const params = { email };

    const { data:body } = await apiStore.axios.get( paths.forgotpassword, { params });

    logger.log( body );

    return  body;
}

const updateUser = async ( payload = {} ) => {
    const { subscriberId, ...data } = payload ;
    const path = `${ paths.updateSubscriber }/${ subscriberId }` ;
    const { data: body } = await apiStore.axios.put( path, data );
    if( body.error || body.errordata )throw body ;
    return body ;
}




function syncLocalUserData ( payload = {} ){

    const encryptedData = localStore.get( '__userdata__' );
    logger.log('encrypted data: ', encryptedData );
    const userData =  encryptedData ? crypto.decrypt( encryptedData ): null;

    return { ...payload, ...userData };
}


function storeUserDetails( payload ){
    const encryptedData =crypto.encrypt( payload );
    localStore.set('__userdata__', encryptedData );
}

export {
    fetchEmail,
    fetchLogin,
    fetchSignUp,
    requestLogout,
    fetchForgotPassword,
    updateUser
}